/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateShiftAreaData,
  CreateShiftAreaResponse,
  ListShiftAreasResponse,
  ShowShiftAreaResponse,
  UpdateShiftAreaData,
  UpdateShiftAreaResponse,
} from '../models/index';
import {
    CreateShiftAreaDataFromJSON,
    CreateShiftAreaDataToJSON,
    CreateShiftAreaResponseFromJSON,
    CreateShiftAreaResponseToJSON,
    ListShiftAreasResponseFromJSON,
    ListShiftAreasResponseToJSON,
    ShowShiftAreaResponseFromJSON,
    ShowShiftAreaResponseToJSON,
    UpdateShiftAreaDataFromJSON,
    UpdateShiftAreaDataToJSON,
    UpdateShiftAreaResponseFromJSON,
    UpdateShiftAreaResponseToJSON,
} from '../models/index';

export interface CreateShiftAreaRequest {
    _with?: Array<string>;
    createShiftAreaData?: CreateShiftAreaData;
}

export interface ListShiftAreasRequest {
    limit?: number;
    orderBy?: Array<string>;
    page?: number;
    perPage?: number;
    where?: { [key: string]: object; };
    _with?: Array<string>;
}

export interface ShowShiftAreaRequest {
    id: number;
    _with?: Array<string>;
}

export interface UpdateShiftAreaRequest {
    id: number;
    _with?: Array<string>;
    updateShiftAreaData?: UpdateShiftAreaData;
}

/**
 * 
 */
export class ShiftAreaApi extends runtime.BaseAPI {

    /**
     * Create a new Shift Area
     * Create Shift Area
     */
    async createShiftAreaRaw(requestParameters: CreateShiftAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateShiftAreaResponse>> {
        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-area.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-areas`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateShiftAreaDataToJSON(requestParameters['createShiftAreaData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateShiftAreaResponseFromJSON(jsonValue));
    }

    /**
     * Create a new Shift Area
     * Create Shift Area
     */
    async createShiftArea(requestParameters: CreateShiftAreaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateShiftAreaResponse> {
        const response = await this.createShiftAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all Shift Areas
     * List Shift Areas
     */
    async listShiftAreasRaw(requestParameters: ListShiftAreasRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListShiftAreasResponse>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['perPage'] != null) {
            queryParameters['perPage'] = requestParameters['perPage'];
        }

        if (requestParameters['where'] != null) {
            queryParameters['where'] = requestParameters['where'];
        }

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-area.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-areas`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListShiftAreasResponseFromJSON(jsonValue));
    }

    /**
     * List all Shift Areas
     * List Shift Areas
     */
    async listShiftAreas(requestParameters: ListShiftAreasRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListShiftAreasResponse> {
        const response = await this.listShiftAreasRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Show a single Shift Area
     * Show Shift Area
     */
    async showShiftAreaRaw(requestParameters: ShowShiftAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShowShiftAreaResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling showShiftArea().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-area.read"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-areas/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShowShiftAreaResponseFromJSON(jsonValue));
    }

    /**
     * Show a single Shift Area
     * Show Shift Area
     */
    async showShiftArea(requestParameters: ShowShiftAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShowShiftAreaResponse> {
        const response = await this.showShiftAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a shift area
     * Update Shift Area
     */
    async updateShiftAreaRaw(requestParameters: UpdateShiftAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateShiftAreaResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateShiftArea().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['_with'] != null) {
            queryParameters['with'] = requestParameters['_with'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", ["api.v1.shift-area.write"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/shift-areas/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateShiftAreaDataToJSON(requestParameters['updateShiftAreaData']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateShiftAreaResponseFromJSON(jsonValue));
    }

    /**
     * Update a shift area
     * Update Shift Area
     */
    async updateShiftArea(requestParameters: UpdateShiftAreaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateShiftAreaResponse> {
        const response = await this.updateShiftAreaRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
